import { observer } from 'mobx-react-lite';
import { Gauge } from '@phosphor-icons/react';
import { useResolve } from '@/infrastructure/useResolve';
import { TOKEN_II18n } from '@/services/i18n/I18n';
import { TOKEN_PlayerStore } from './PlayerStore';

const pill =
  'flex items-center gap-1.5 rounded-full border border-line bg-surface px-3 py-1.5 text-sm text-ink';

export const SpeedSelectorView = observer(function SpeedSelectorView() {
  const store = useResolve(TOKEN_PlayerStore);
  const i18n = useResolve(TOKEN_II18n);
  return (
    <label className={pill} title={i18n.t('speed.label')}>
      <Gauge size={16} className="text-muted" />
      <select
        value={store.speed}
        onChange={(e) => store.setSpeed(Number(e.target.value))}
        className="cursor-pointer bg-transparent tabular-nums outline-none"
      >
        {store.speedOptions.map((s) => (
          <option key={s} value={s}>
            {s}×
          </option>
        ))}
      </select>
    </label>
  );
});
